@if (!alignToLeft) {
  <div
    nxLayout="grid maxwidth"
    class="t-bg-white">
    <div nxRow>
      <div nxCol="12,12,1,3"></div>
      <div
        nxCol="12,12,10,6"
        class="u-text-center">
        <nx-message
          aria-live="polite"
          context="info"
          class="nx-margin-bottom-0">
          <span [innerHTML]="content"></span>
        </nx-message>
      </div>
      <div nxCol="12,12,1,3"></div>
    </div>
  </div>
}
@if (alignToLeft) {
  <div
    nxLayout="grid"
    class="t-bg-white">
    <div nxRow>
      <div
        nxCol="12"
        class="u-text-center padding-left-0">
        <nx-message
          aria-live="polite"
          context="info"
          class="nx-margin-bottom-0">
          <span [innerHTML]="content"></span>
        </nx-message>
      </div>
      <div nxCol="4"></div>
    </div>
  </div>
}
